const BASE_DINER_ENDPOINT = '/diner';

export const BEGIN_DINER_AUTH_ENDPOINT = `${BASE_DINER_ENDPOINT}/begin_auth`;
export const COMPLETE_DINER_LOGIN_ENDPOINT = `${BASE_DINER_ENDPOINT}/login`;
export const GET_CURRENT_USER_ENDPOINT = `${BASE_DINER_ENDPOINT}/current_user`;
export const RESERVATIONS_BRAND_STYLES_ENDPOINT = '/api/reservations/brand/';
export const GET_FEEDBACK_REQUEST_URL_ENDPOINT =
  '/api/reservations-feedback-url';
export const GET_RECEIPT_URL_ENDPOINT = '/pos_integrations/receipt';
